import { render, staticRenderFns } from "./EditBankHolder.vue?vue&type=template&id=697202f8&scoped=true&"
import script from "./EditBankHolder.vue?vue&type=script&lang=js&"
export * from "./EditBankHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697202f8",
  null
  
)

export default component.exports